<div class="page-wrapper" style="min-height: 347px">
  <div class="content container-fluid">
    <div class="bg-white page-border">
      <div class="col-md-12 container-fluid">
        <div class="row">
          <div class="col-md-3" style="z-index: 999">
            <div
              class="justify-content-center align-items-center cus-margin"
              *ngIf="empData"
            >
              <div class="card text-center card-home">
                <div class="upper"></div>
                <div class="user bg-white" style="height: 275px !important">
                  <div class="w-100 profile" *ngIf="newsStat">
                    <img
                      [src]="empData.emp_img"
                      class="rounded-circle"
                      width="100"
                    />
                    <p class="h4 font-weight-bold mb-0">
                      {{ empData.emp_name }}
                      <span class="font-weight-normal">
                        <img
                          src="assets/img/news/medal_gold.svg"
                          *ngIf="newsStat.club_id == 1"
                        />
                        <img
                          src="assets/img/news/medal_silver.svg"
                          *ngIf="newsStat.club_id == 2"
                        />
                        <img
                          src="assets/img/news/medal_broze.svg"
                          *ngIf="newsStat.club_id == 3"
                        />
                      </span>
                    </p>
                    <span class="font-weight-normal">
                      {{ empData.cc_desc }}
                    </span>
                    <div class="liks_sec mt-2 pt-3 border-top border_bottom">
                      <div class="row">
                        <div class="col-md-6 border-right">
                          <div class="liks_part">
                            <h4 class="font-weight-bold">
                              {{ newsStat.like_count }}
                            </h4>
                            <p class="font-weight-normal">
                              {{ "My Likes" | translate }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="liks_part">
                            <h4 class="font-weight-bold">
                              {{ newsStat.comment_count }}
                            </h4>
                            <p class="font-weight-normal">
                              {{ "My Comments" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="border-top pb-2">
                        <div class="row">
                          <div class="col-12 mt-3">
                            <div class="liks_part">
                              <h4 class="font-weight-bold">
                                {{ newsStat.score }}
                                <span
                                  ><i class="fa fa-signal text-secondary"></i
                                ></span>
                              </h4>
                              <p class="font-weight-normal">
                                {{ "My Contribution" | translate }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-home mt-3" cdkDrag>
              <div class="card-header1 heading1 border-up bg-main color_g">
                <p class="position-relative d-inline font-weight-bold">
                  {{ "Trend Now With Us!" | translate }}
                </p>
              </div>
              <div class="font_s p-3 border_bottom">
                <p class="mt-2">
                  {{
                    "Join our News Creator Club and gain entry to the GOLD, SILVER & BRONZE CLUB"
                      | translate
                  }}
                </p>
                <div class="font_s p-3 border_bottom">
                  <div class="row">
                    <div class="col-4 m-0 p-0 pp_1">
                      <div class="img_part">
                        <img src="assets/img/news/medal_gold.svg" />
                      </div>
                    </div>
                    <div class="col-4 m-0 p-0 pp_1">
                      <div class="img_part">
                        <img src="assets/img/news/medal_silver.svg" />
                      </div>
                    </div>
                    <div class="col-4 m-0 p-0 pp_1">
                      <div class="img_part">
                        <img src="assets/img/news/medal_broze.svg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="down_sec">
                <ul class="nav d-flex py-3 px-3">
                  <li
                    class="w-50 cursor"
                    (click)="openClubModal('#club_modal')"
                  >
                    <i class="fa fa-plus text-danger"></i>
                    {{ "Read More" | translate }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="card-home mt-3" cdkDrag>
              <div class="card-header1 heading1 border-up bg-main color_g">
                <p class="position-relative d-inline font-weight-bold">
                  {{ "Share Your News!" | translate }}
                </p>
              </div>
              <div class="font_s p-3">
                <p class="mt-2">
                  {{ "Do you have anything to share ?" | translate }}
                </p>
              </div>
              <div class="pb-3 text-center">
                <button
                  type="button"
                  class="btn btn-danger p-2"
                  (click)="siteNewsModal('#site_news_modal')"
                >
                  {{ "SUBMIT HERE" | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-6 pos_fix">
            <div class="news_header p-2 font-weight-bold h3 color_white">
              {{ headerName | translate }}
              <i
                class="fa fa-home float-right cursor"
                title="Go Back To My Feed"
                (click)="goToMyFeed()"
              ></i>
            </div>
            <!--end-->

            <div
              *ngIf="newsData.length == 0 && hasData"
              class="texxt-center data_check"
            >
              <img src="assets/img/empty.gif" style="width: 45%" />
              <h4 class="data_check">{{ "No News Found !" | translate }}</h4>
            </div>

            <div
              class="mt-3 card-home"
              *ngFor="let data of newsData; let i = index"
            >
              <div
                class="shadow-main text-color-main bg-white border-down border-up border-0 mb-3 pb-2"
              >
                <div class="d-flex px-3 py-3 border_bottom">
                  <div class="row">
                    <div class="col-12">
                      <h3 class="font-weight-bold">
                        {{ data.news_title }}
                      </h3>
                    </div>
                  </div>
                </div>

                <div class="ml-2 pt-2 px-3">
                  <p *ngIf="data.short_desc">{{ data.short_desc }}</p>
                </div>
                <div class="ml-2 pt-2 px-3">
                  <div
                    *ngIf="data.content.length > 150; else underLimit"
                    [innerHTML]="data.content"
                  ></div>
                  <ng-template #underLimit>
                    <div [innerHTML]="data.content"></div>
                  </ng-template>
                </div>
                <div class="mt-2 px-3 img_sec">
                  <owl-carousel-o
                    [options]="customOptions"
                    *ngIf="data.img_arr.length > 0"
                  >
                    <ng-container *ngFor="let slide of data.img_arr">
                      <ng-template carouselSlide>
                        <img [src]="slide" />
                      </ng-template>
                    </ng-container>
                  </owl-carousel-o>

                  <owl-carousel-o
                    [options]="vdoOptions"
                    *ngIf="data.vdo_arr.length > 0"
                  >
                    <ng-container *ngFor="let slide of data.vdo_arr">
                      <ng-template carouselSlide>
                        <video
                          height="380"
                          controls
                          class="vdoCustom"
                          width="100%"
                        >
                          <source [src]="slide" />
                        </video>
                      </ng-template>
                    </ng-container>
                  </owl-carousel-o>

                  <div
                    class="mt-2"
                    style=""

                    *ngIf="data.youtube_files.length > 0"
                  >
                    <span *ngFor="let link of data.youtube_files">
                      <youtube-player videoId="{{ link }}"></youtube-player>
                    </span>
                  </div>

                  <div *ngIf="data.files.length > 0" class="mt-2">
                    <a
                      *ngFor="let attch of data.files; let i = index"
                      [href]="attch"
                      target="_blank"
                    >
                      <div class="btn-group btn-group-sm">
                        <button class="btn-primary">
                          <i class="fa fa-paperclip"></i> Attachment
                          {{ i + 1 }}
                        </button>
                      </div>
                      <br />
                      <br />
                    </a>
                  </div>
                </div>

                <div class="pt-2 px-3 cus-img12">
                  <div class="d__flex border-top">
                    <div class="mb-2 mt-2">
                      <b>
                        <span (click)="toggleContent(data)" class="cursor">
                          <i
                            class="fa fa-plus text-danger"
                            *ngIf="!data.isContentToggled"
                          ></i>
                          <i
                            class="fa fa-minus text-danger"
                            *ngIf="data.isContentToggled"
                          ></i>
                          {{
                            data.isContentToggled
                              ? ("Read Less" | translate)
                              : ("Read More" | translate)
                          }}</span
                        >
                        &nbsp; &nbsp;
                        <span (click)="pinNews(data)" class="cursor"
                          ><img
                            src="assets/img/news/pin.svg"
                            style="width: 12px"
                          />
                          {{
                            data.can_pin == true
                              ? ("PIN" | translate)
                              : ("UNPIN" | translate)
                          }}
                        </span>
                      </b>
                    </div>
                    <div class="">
                      <p class="mb-2 pt-1" *ngIf="data.likes_allowed == 1">
                        <b>{{ data.like_desc }} &nbsp;</b>

                        <span
                          class="float-right fw-500 cursor"
                          (click)="likeUnlikeNews(data, 1)"
                          >{{ data.like_count}}{{"likes" | translate}}
                          <img
                            src="assets/new_icon/like.svg"
                            class="ancor icon-main ml-3"
                          />
                          <b>
                            {{
                              data.can_like == true
                                ? ("LIKE" | translate)
                                : ("LIKED" | translate)
                            }}</b
                          ></span
                        >
                      </p>
                    </div>
                  </div>

                  <div class="d-flex mt-1 pb-1" *ngIf="data.comment_allwd == 1">
                    <img
                      width="30"
                      [src]="data.emp_img"
                      onError="src = 'assets/img/profile.webp'"
                    />
                    <div class="input-group ml-2">
                      <input
                        type="text"
                        class="form-control bg-light"
                        placeholder="Write a comment..."
                        [(ngModel)]="data.usr_comment"
                        aria-label="Write a comment..."
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append cursor">
                        <button
                          class="btn bg-light btn-outline-secondary py-0 px-2"
                          (click)="doCommentNews(data, data.txn_id, 1)"
                          type="button"
                        >
                          <img
                            src="assets/new_icon/send.svg"
                            class="icon-main"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="data.comment_allwd == 1">
                    <p class="mt-2 mb-1 text-color-second">
                      {{ data.comment_count }} {{ "comments" | translate }}
                    </p>
                  </div>
                  <div
                    *ngIf="data.comment_count > 0 && data.comment_allwd == 1"
                  >
                    <ul
                      class="list-group list-group-flush pt-0 pb-0"
                      *ngFor="let cmnt of data.comment_arr; let i = index"
                    >
                      <li
                        class="list-group-item border-white pt-1 pb-1 d-flex bg-main border-r-15"
                        *ngIf="i < data.commentIndex"
                      >
                        <img
                          height="34"
                          class="mr-2 rounded-circle"
                          [src]="cmnt.emp_img"
                          onError="src = 'assets/img/profile.webp'"
                        />
                        <span *ngIf="i < data.commentIndex">
                          <b>{{ cmnt.name }} {{ cmnt.lname }} </b>
                          <small>{{ cmnt.date }}</small
                          ><br />
                          {{ cmnt.comment }}
                          <br />
                          <br />
                        </span>
                      </li>
                      <span
                        class="d-flex ml-5 cenr"
                        *ngIf="i < data.commentIndex"
                      >
                        <span
                          class="float-right fw-500 cursor mr-2"
                          (click)="likeUnlikeNews(cmnt, 2)"
                        >
                          <b class="pr-2">
                            {{
                              cmnt.can_like == true
                                ? ("Like" | translate)
                                : ("Liked" | translate)
                            }}
                          </b></span
                        >
                        <span
                          class="float-right fw-500 cursor mr-2"
                          (click)="cmnt.show_comment = !cmnt.show_comment"
                        >
                          <b> {{ "Reply" | translate }} </b></span
                        >
                      </span>

                      <div
                        class="d-flex border-r-15 pt-1 pb-1 px-3 ml-5 mb-2"
                        *ngIf="cmnt.show_comment == true"
                      >
                        <img
                          width="30"
                          [src]="cmnt.emp_img"
                          onError="src = 'assets/img/profile.webp'"
                        />
                        <div class="input-group ml-2">
                          <input
                            type="text"
                            class="form-control bg-light"
                            placeholder="Send Reply..."
                            [(ngModel)]="cmnt.usr_comment"
                          />
                          <div class="input-group-append cursor">
                            <button
                              class="btn bg-light btn-outline-secondary py-0 px-2"
                              (click)="doCommentNews(cmnt, cmnt.txn_id, 2)"
                              type="button"
                            >
                              <img
                                src="assets/new_icon/send.svg"
                                class="icon-main"
                              />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mt-2" *ngIf="i < data.commentIndex">
                        <div
                          *ngFor="let rpl of cmnt.reply_arr"
                          class="border-r-15 pt-1 pb-1 px-3 ml-5 bg-main mb-2"
                        >
                          <img
                            height="34"
                            class="mr-2 rounded-circle"
                            [src]="rpl.emp_img"
                            onError="src = 'assets/img/profile.webp'"
                          />
                          <span class="rgr">
                            <b>{{ rpl.name }} {{ rpl.lname }} </b>
                            <small>{{ rpl.date }}</small>
                            <br />
                            {{ rpl.comment }}
                            <br />
                            <br />
                          </span>
                        </div>
                      </div>
                    </ul>

                    <p
                      class="text-color-second ml-auto mb-0 cursor"
                      (click)="viewAllCommentNews(data)"
                      *ngIf="
                        data.comment_count > data.commentIndex &&
                        data.commentIndex <= data.comment_arr.length
                      "
                    >
                      {{ "View more comments" | translate }}
                    </p>
                    <p
                      class="text-color-second mb-0 cursor"
                      (click)="hideCommentsNews(data)"
                      *ngIf="
                        data.comment_count > 2 &&
                        data.commentIndex >= data.comment_arr.length
                      "
                    >
                      {{ "Hide comments" | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="text-center mb-5"
              *ngIf="newsData.length > 0 && !isLastNewsPage"
            >
              <button
                type="button"
                class="btn bg-main2 text-white px-2 py-1"
                (click)="moreNews()"
              >
                {{ "View more News" | translate }}
              </button>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card-home" cdkDrag>
              <div class="card-header1 heading1 border-up bg-main color_y">
                <p class="position-relative d-inline font-weight-bold">
                  {{ "News Categories" | translate }}
                </p>
              </div>
              <ul class="bg-white news_ul px-3 pt-3">
                <li
                  class="nav-item p-2 h5 border_bottom cursor"
                  *ngFor="let data of categories; let i = index"
                  (click)="getCategNews(data)"
                >
                  <img [src]="data.icon" style="height: 30px" />
                  <span>{{ data.label | translate }}</span>
                </li>
              </ul>
            </div>

            <div class="card-home mt-3" cdkDrag *ngIf="trendingArr.length > 0">
              <div class="card-header1 heading1 border-up bg-main color_y">
                <p class="position-relative d-inline font-weight-bold">
                  {{ "What's Hot!" | translate }}
                  <span class="img_hot"
                    ><img src="assets/img/news/fire.svg"
                  /></span>
                </p>
              </div>
              <div
                *ngFor="let data of trendingArr; let i = index"
                class="card mb-2"
              >
                <div class="font_s p-3 border_bottom">
                  <h4 class="font-weight-bold">{{ data.news_title }}</h4>
                  <p class="mt-2">
                    {{ data.short_desc }}
                  </p>
                </div>
                <div class="down_sec">
                  <ul class="nav d-flex py-3 px-3">
                    <li class="w-50 cursor" (click)="readMore(data)">
                      <i class="fa fa-plus text-danger"></i>
                      {{ "Read More" | translate }}
                    </li>
                    <li class="w-50 cursor" (click)="pinNews(data)">
                      <img src="assets/img/news/pin.svg" style="width: 16px" />
                      {{
                        data.can_pin == true
                          ? ("PIN" | translate)
                          : ("UNPIN" | translate)
                      }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-home mt-3" cdkDrag>
              <div class="card-header1 heading1 border-up bg-main color_y">
                <p class="position-relative d-inline font-weight-bold">
                  {{ "Photo Gallery" | translate }}
                </p>
              </div>

              <div class="font_s p-3 border_bottom">
                <div class="row">
                  <div
                    class="col-6 m-0 p-0 pp_1"
                    *ngFor="let data of galleryData; let i = index"
                  >
                    <div
                      class="card border-0"
                      (click)="
                        openGalleryModal('#image_gallery_modal', i, true)
                      "
                      *ngIf="i < glryIndex"
                    >
                      <img
                        [src]="data.thumbnail"
                        [title]="data.event_name"
                        style="height: auto"
                      />
                      <div
                        class="card w-100 p-2 h-100 rounded-0 position-absolute top-0"
                        style="background-color: rgba(0, 0, 0, 0.5)"
                      >
                        <span
                          style="font-size: 10px"
                          class="mt-auto text-light"
                          [title]="data.event_name"
                        >
                          {{
                            data.event_name.length > 12
                              ? (data.event_name | slice : 0 : 12) + ".."
                              : (data.event_name | translate)
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pb-3" *ngIf="galleryData.length > 0; else noGlry">
                  <p
                    class="text-color-second ml-auto mb-0 cursor"
                    (click)="viewMoreGallery()"
                    *ngIf="
                      galleryData.length > glryIndex &&
                        glryIndex <= galleryData.length;
                      else hideBlock
                    "
                  >
                    <u>{{ "View More Events" | translate }}</u>
                  </p>
                  <ng-template #hideBlock>
                    <p
                      class="text-color-second mb-0 cursor"
                      (click)="hideGallery()"
                    >
                      <u>{{ "Hide Events" | translate }}</u>
                    </p>
                  </ng-template>
                </div>
                <ng-template #noGlry>
                  <p class="text-center">
                    {{ "No Photos Found!" | translate }}
                  </p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="club_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          {{ "News Creator Club" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <b>
              {{
                "Gain entry into the gold, silver, or bronze club based on your news sharing frequency!"
                  | translate
              }}</b
            >
            <br />
            <br />
            <ol class="list-group list-group-numbered">
              <li class="list-group-item">
                <span class="img_part">
                  <img src="assets/img/news/medal_gold.svg" style="width: 5%" />
                </span>
                {{
                  "Submit at least 3 admin approved news posts in a week and enter the Gold Club."
                    | translate
                }}
              </li>
              <li class="list-group-item">
                <span class="img_part">
                  <img
                    src="assets/img/news/medal_silver.svg"
                    style="width: 5%"
                  />
                </span>
                {{
                  "Submit at least 2 admin approved news posts in a week and enter the Silver Club."
                    | translate
                }}
              </li>
              <li class="list-group-item">
                <span class="img_part">
                  <img
                    src="assets/img/news/medal_broze.svg"
                    style="width: 5%"
                  />
                </span>
                {{
                  "Submit at least 1 admin approved news post in a week and enter the Bronze Club."
                    | translate
                }}
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  id="image_gallery_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          {{ "Photo Gallery" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeGalleryModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-3">
            <h3>{{ "Event List" | translate }}</h3>
            <div class="row" style="height: 500px; overflow: scroll">
              <div
                class="col-6 p-1"
                [class.active]="data.is_active"
                *ngFor="let data of galleryData; let i = index"
                (click)="openGalleryModal('#image_gallery_modal', i, false)"
              >
                <div class="card border-0">
                  <img
                    [src]="data.thumbnail"
                    [title]="data.event_name"
                    style="height: auto"
                  />
                  <div
                    class="card w-100 p-2 h-100 rounded-0 position-absolute top-0"
                    style="background-color: rgba(0, 0, 0, 0.5)"
                  >
                    <span
                      style="font-size: 10px"
                      class="mt-auto text-light"
                      [title]="data.event_name"
                    >
                      {{
                        data.event_name.length > 12
                          ? (data.event_name | slice : 0 : 12) + ".."
                          : (data.event_name | translate)
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <h4 class="text-center mt-3">{{ crntEvent }}</h4>
            <div class="mt-4 px-3 img_sec">
              <div
                id="carouselExampleControlsGallery"
                class="carousel slide"
                style="height: 500px; overflow: scroll"
                data-ride="carousel"
                *ngIf="imagesArr.length > 0"
              >
                <div class="carousel-inner">
                  <div
                    class="carousel-item"
                    *ngFor="let dc of imagesArr; let i = index"
                    [class.active]="i == 0"
                  >
                    <img
                      [src]="dc.doc"
                      alt="{{ i + 1 + ' Slide' }}"
                      title="{{ i + 1 + ' Slide' }}"
                    />
                  </div>
                </div>
                <a
                  class="carousel-control-prev"
                  href="#carouselExampleControlsGallery"
                  role="button"
                  data-slide="prev"
                >
                  <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">{{ "Previous" | translate }}</span>
                </a>
                <a
                  class="carousel-control-next"
                  href="#carouselExampleControlsGallery"
                  role="button"
                  data-slide="next"
                >
                  <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">{{ "Next" | translate }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          (click)="closeGalleryModal()"
        >
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  id="site_news_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          {{ "Upload News" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeSiteNewsModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form [formGroup]="siteNewsForm" (ngSubmit)="submitNews()">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label
                  >{{ "News Title" | translate
                  }}<span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  formControlName="news_title"
                  type="text"
                  placeholder="Title"
                />
                <div
                  *ngIf="submit && newsError.news_title.errors"
                  class="form-error"
                >
                  <div *ngIf="newsError.news_title.errors.required">
                    {{ "News Title is required !" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ "Short Description" | translate }}</label>
                <input
                  class="form-control"
                  formControlName="short_desc"
                  type="text"
                  placeholder="Short Description"
                />
                <div
                  *ngIf="submit && newsError.short_desc.errors"
                  class="form-error"
                >
                  <div *ngIf="newsError.short_desc.errors.required">
                    {{ "Short Description is required !" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label
                  >{{ "News Description" | translate
                  }}<span class="text-danger">*</span></label
                >
                <angular-editor
                  formControlName="news_desc"
                  placeholder="Enter News description here..."
                  [config]="editorConfig"
                ></angular-editor>
                <div
                  *ngIf="submit && newsError.news_desc.errors"
                  class="form-error"
                >
                  <div *ngIf="newsError.news_desc.errors.required">
                    {{ "News Description is required !" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <input
                #fileInput
                type="file"
                (change)="onChooseFile($event, 1)"
                style="display: none"
              />
              <div
                class="dropzone"
                DropZone
                (onFileDropped)="droppedFiles($event)"
              >
                <div class="text-center" (click)="fileInput.click()">
                  {{ "Drop files here." | translate }}<BR />
                  <span class="note needsclick"
                    >({{
                      "You can choose files by click on grey area as well."
                        | translate
                    }})</span
                  >
                </div>
              </div>

              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">{{ "File Name" | translate }}</th>
                    <th scope="col">{{ "Size" | translate }}</th>
                    <th scope="col">{{ "Type" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let file of allFiles; let i = index">
                    <th scope="row">
                      <button
                        type="button"
                        class="btn-danger"
                        (click)="deleteIndex(i)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                      {{ i + 1 }}
                    </th>
                    <td>{{ file.name }}</td>
                    <td>{{ file.size }} Bytes</td>
                    <td>{{ file.type }}</td>
                  </tr>
                  <tr class="text-center" *ngIf="allFiles.length === 0">
                    <td colspan="4">
                      <strong>{{ "No files are selected" | translate }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">
            {{ "SAVE" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            (click)="closeSiteNewsModal()"
          >
            {{ "Close" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  id="lang_modal_nws"
  class="modal custom-modal fade"
  role="dialog"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xs" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Select Preferred Language</h5>
      </div>
      <div class="modal-body">
        <div class="bg-main border-up-down shadow-main height-same-req">
          <form>
            <div class="col-md-12 req-vis-card-form">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label
                      >Select Language <span class="text-danger">*</span></label
                    >
                    <select class="form-control" (change)="getLanguage($event)">
                      <option [value]="">Select</option>
                      <option
                        *ngFor="let data of languageList"
                        [value]="data.value"
                      >
                        {{ data.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
